import { Order } from 'entities/Order/model/types/OrderSchema';
import { isProposalInAvailabilityCheck } from 'entities/Proposal/lib/isProposalInAvailabilityCheck';
import { isProposalInPriceCheck } from 'entities/Proposal/lib/isProposalInPriceCheck';

import { orderCanShowPriceLoading } from '../orderCanShowPriceLoading/orderCanShowPriceLoading';

interface PendingChecksResponse {
    hasPendingChecks: boolean;
    itemsAwaitingPrices: boolean;
    itemsAwaitingAvailability: boolean;
}

export const orderHasPendingPnAChecks = function (
    order: Order,
): PendingChecksResponse {
    const items = order?.items;

    if (orderCanShowPriceLoading(order) && items.length > 0) {
        const itemsAwaitingPrices = items.some(
            (item) =>
                item.isCheckFinished !== true &&
                isProposalInPriceCheck(item?.proposals),
        );

        const itemsAwaitingAvailability = items.some(
            (item) =>
                item.isCheckFinished !== true &&
                isProposalInAvailabilityCheck(item?.proposals),
        );

        const hasUnfinishedItemChecks = items.some(
            (item) => item.isCheckFinished !== true,
        );

        const orderChecksIncomplete = order.isAllItemChecksFinished !== true;

        return {
            hasPendingChecks:
                hasUnfinishedItemChecks ||
                orderChecksIncomplete ||
                itemsAwaitingPrices ||
                itemsAwaitingAvailability,
            itemsAwaitingPrices,
            itemsAwaitingAvailability,
        };
    }

    return {
        hasPendingChecks: false,
        itemsAwaitingPrices: false,
        itemsAwaitingAvailability: false,
    };
};
